var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1,.cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:40px;}.cls-1{stroke-linejoin:round;}.cls-2{stroke-miterlimit:10;fill-rule:evenodd;}")),React.createElement("path",{"className":"cls-1","d":"M-511.48,444.59s140.83-75.17,411.33-457.17c0,0,151.67-194.33,156.17-409.83,0,0-170.34-30.39-417.35,586.12,0,0-113.87,252.18,67.35,274.88,0,0,109.78,18,355.89-228,0,0,43.61-53.5,51.11-108,0,0-42.1,1.1-110,69l84.12,61.24s107.44,61.28,71.76,134c0,0-25.68,51.72-71.53,25.72,0,0,21.65-137,337.65-164","transform":"translate(531.48 442.65)","key":1}),React.createElement("path",{"className":"cls-2","d":"M521.05,266.08s12.13-29.3,39.41-40.92","transform":"translate(531.48 442.65)","key":2})]);
}

Logo.defaultProps = {"id":"Layer_2","data-name":"Layer 2","viewBox":"0 0 1111.94 907.24"};

module.exports = Logo;

Logo.default = Logo;
